import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 1,
      name: i18n.t('tipos.reporting_activo.verifactu')
    },
    {
      id: 2,
      name: i18n.t('tipos.reporting_activo.tbai')
    },
    {
      id: 3,
      //   name: i18n.t('tipos.reporting_activo.sii')
      name: 'Suministro Inmediato de Información (SII)'
    }
  ]
}

export function TIPOS_REPORTING_ACTIVO (state) {
  return configHelper.getConfig(state, 'TIPOS_REPORTING_ACTIVO', GenerateConfig)
}
